import { styled } from "~/common/mui";

const SAVED_CONFIGURATIONS_COLUMNS = "3% 30.6% minmax(0, 54.6%) 11.8%";

export const SavedConfigurationsTableLayout = styled("div")(({ theme }) => ({
  color: theme.palette.text.primary,
  display: "flex",
  flexDirection: "column",
}));

export const SavedConfigurationsTableHeader = styled("div")(({ theme }) => ({
  ...theme.typography.bodyMedium,
  display: "grid",
  gridTemplateColumns: SAVED_CONFIGURATIONS_COLUMNS,
  fontWeight: "bold",
  borderBottom: `3px solid ${theme.palette.divider}`,
}));

export const SavedConfigurationsTableRow = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: SAVED_CONFIGURATIONS_COLUMNS,
  width: "100%",
  paddingTop: theme.spacing(3.75),
  paddingBottom: theme.spacing(3.75),
}));

export const SavedConfigurationDetailsCell = styled("div")({
  gridColumn: "3 / 5",
  minWidth: 0,
});

export const SavedConfigurationDetailsLayout = styled("div")({
  display: "grid",
  gridTemplateColumns: "minmax(0, 82.2289%) 17.7711%",
  width: "100%",
});
